module.exports = __webpack_public_path__ + "media/assets/images/flags/gf-c8cd6aa18e4dec5d9da5125841db5b9c.svg";